import { render, staticRenderFns } from "./traffic.vue?vue&type=template&id=881ce82c&"
import script from "./traffic.vue?vue&type=script&lang=ts&"
export * from "./traffic.vue?vue&type=script&lang=ts&"
import style0 from "./traffic.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports